import {
  CellDisplayConfig,
  CellEditConfig,
  CellFooterConfig,
  IIdentity,
  TooltipConfig,
} from '.';
import { GridAlignment } from '../enums';
import { HeaderOptions } from './header-options.model';

export interface GridColumn<T extends IIdentity> {
  columnDef: string;
  header?: HeaderOptions<T>;
  placeholder?: string;
  tabIndex?: number | ((data: T) => number);
  /**
   * @description don't define this if you want the column to be auto
   */
  width?: number;
  /**
   * @description mandatory for auto columns (if width is not defined)
   */
  minWidth?: number;
  customClassList?: string[];
  columnAlignment?: GridAlignment | ((data: T) => GridAlignment);
  edit?:
    | CellEditConfig<T>
    | ((data: T, cell: HTMLElement) => CellEditConfig<T>);
  onCellEdited?: (data: T, oldValue?: any) => void;
  allowEditing?: boolean;
  allowSorting?: boolean;
  display?:
    | CellDisplayConfig<T>
    | ((data: T, cell: HTMLElement) => CellDisplayConfig<T>);
  tooltip?: TooltipConfig<T>;
  bindClickEvent?: boolean;
  recomputeRowOnChange?: boolean;
  /**
   * @description Don't mark the cell as changed when it is edited
   */
  disableChangeHighlighting?: boolean;
  /**
   * @description Don't mark the cell as focused
   */
  disableFocusedBackground?: boolean | ((data: T) => boolean);
  footer?: CellFooterConfig;
}
